export const ROUTE_NAMES = {
    AUCTION_LISTING: 'auctions-localizedAssetType-optionalParams',
    AUCTION_DETAIL: 'auctions-dp-slug',
    AUCTION_DETAIL_NEGOTIATION: 'auctions-dp-slug-negotiation',
    DIRECT_SALE_LISTING: 'direct-sales-localizedAssetType-optionalParams',
    DIRECT_SALE_DETAIL: 'direct-sales-dp-slug',
    DIRECT_SALE_DETAIL_NEGOTIATION: 'direct-sales-dp-slug-negotiation',

    // Account
    ACCOUNT_BIDS: 'account-bids',
    ACCOUNT_PROFILE: 'account-profile',
    ACCOUNT_VEHICLES_FOR_SALE: 'account-vehicles-for-sale',
    ACCOUNT_SOLD_VEHICLES: 'account-sold-vehicles',
    ACCOUNT_BUYER_NEGOTIATIONS: 'account-buyer-negotiations',
    ACCOUNT_SELLER_NEGOTIATIONS: 'account-seller-negotiations',
    ACCOUNT_ORDERS_AUCTION: 'account-orders-auction',
    ACCOUNT_ORDERS: 'account-orders',
    ACCOUNT_ORDER: 'account-orders-id',
    ACCOUNT_ORDER_THANK_YOU: 'account-orders-id-thank-you',
    ACCOUNT_ORDER_EDIT: 'account-orders-id-edit',
    ACCOUNT_ORDER_EDIT_PAYMENT: 'account-orders-id-edit-payment',
    ACCOUNT_FAVORITES: 'account-favorites',
    ACCOUNT_SALES_REP_SALES: 'account-sales-rep-sales',
    ACCOUNT_AUCTIONS_VEHICLE_STATS: 'account-vehicle-stats-auctions-id',
    ACCOUNT_DIRECT_SALES_VEHICLE_STATS: 'account-vehicle-stats-direct-sales-id',

    // Smart links
    SMART_LINK_VEHICLE: 'go-v-vin',

    // Storyblok Preview
    STORYBLOK_PREVIEW: 'preview-slug',
} as const;

export const SLP_ROUTE_NAMES = [ROUTE_NAMES.AUCTION_LISTING, ROUTE_NAMES.DIRECT_SALE_LISTING] as const;

export const SDP_ROUTE_NAMES = [
    ROUTE_NAMES.AUCTION_DETAIL,
    ROUTE_NAMES.AUCTION_DETAIL_NEGOTIATION,
    ROUTE_NAMES.DIRECT_SALE_DETAIL,
    ROUTE_NAMES.DIRECT_SALE_DETAIL_NEGOTIATION,
] as const;

export const PROFILE_SECTION_IDS = {
    companyData: 'company-data',
    userData: 'user-data',
    changePassword: 'change-password',
    changeEmail: 'change-email',
    paymentMethods: 'payment-methods',
} as const;

export type RouteName = (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES];

export type SlpRouteName = (typeof SLP_ROUTE_NAMES)[number];

export type SdpRouteName = (typeof SDP_ROUTE_NAMES)[number];
